/**
 * Arrow navigation for a product row that overflows into a scroll-snap
 * carousel. Each click scrolls by roughly one row-width's worth of cards;
 * CSS scroll-snap settles the final position, so the exact distance doesn't
 * need to land on a snap point.
 *
 * Delegated on `document` (rather than a querySelectorAll + forEach at load
 * time) so rows injected later — e.g. the product-recommendations row, which
 * only appears once its async fetch swaps in real content — get the same
 * arrow behavior without needing their own re-init call.
 */
function scrollRow(row, direction) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const amount = row.clientWidth * 0.9 * direction;
  row.scrollBy({ left: amount, behavior: reduceMotion ? 'auto' : 'smooth' });
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const prevButton = event.target.closest('[data-row-prev]');
  const nextButton = event.target.closest('[data-row-next]');
  const button = prevButton || nextButton;
  if (!button) return;

  const wrap = button.closest('[data-row-wrap]');
  const row = wrap?.querySelector('[data-row-scroll]');
  if (!row) return;

  scrollRow(row, prevButton ? -1 : 1);
});
